import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import Drawer from '@mui/material/Drawer';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import StyledCloseButton from '../CircleButton/CircleButton';

const StyledDialogContent = styled.div`
  padding:${({ $padding }) => $padding ?? '20px'};
  margin: 20px;
  min-width: 300px;
  width: ${({ $width }) => $width ?? '40vw'};
  max-width: ${({ $maxWidth }) => $maxWidth ?? 'inherit'};

  ${StyledCloseButton} {
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 9999;
  }
`;

const SideDialog = ({ children, isOpen, onClose, hideCloseButton = false, width, padding = '20px', maxWidth = 'inherit' }) => {
  return ReactDOM.createPortal(
    <Drawer anchor="right" open={isOpen}>
      <StyledDialogContent $width={width} $padding={padding} $maxWidth={maxWidth}>
        {!hideCloseButton && (
          <StyledCloseButton onClick={onClose} type="button">
            <CloseIcon />
          </StyledCloseButton>
        )}
        {children}
      </StyledDialogContent>
    </Drawer>,
    document.body,
  );
};

export default SideDialog;
